import { useEffect, useState } from "react";
import { getPivotTable } from "./CommonFunc";
import { DataGrid, ruRU } from "@mui/x-data-grid";
import CrossIcon from "../Icons/Cross";
function PivotTable() {
	const [rawList, setRawList] = useState([]);
	const [list, setList] = useState([]);
	useEffect(() => {
		getPivotTable().then((res) => {
			setRawList(res);
		});
	}, []);
	useEffect(() => {
		let resFormated = rawList.map((item, i) => ({
			...item,
			id: i,
			DATE_BEG: new Date(item.DATE_BEG),
			DATE_END: new Date(item.DATE_END),
		}));
		setList(resFormated);
	}, [rawList]);
	const columns = [
		// { field: "CNT_ID", headerName: "ID", width: 100 },
		// { field: "ORDER_CODE", headerName: "Код заказа", width: 150 },
		{
			field: "TEST_NAME",
			headerName: "Вид анализа",
			width: 750,
			sortable: false,
		},
		{
			field: "CNT_TEST",
			headerName: "Количество замеров",
			width: 200,
			sortable: false,
		},
		{
			field: "DATE_BEG",
			headerName: "Дата первого замера",
			width: 200,
			sortable: false,
			type: "date",
		},
		{
			field: "DATE_END",
			headerName: "Дата последнего замера",
			width: 200,
			sortable: false,
			type: "date",
		},
		{
			field: "STATUS",
			headerName: "",
			width: 50,
			sortable: false,
			cellClassName: (params) => {
				return `health-app-theme--cell ${
					params.value === 1
						? "norm"
						: params.value === 2
						? "deviations"
						: "last-with-deviations"
				}`;
			},
		},
	];
	return (
		<div>
			<div style={{ height: "calc(100% - 4em)", width: "100%" }}>
				<DataGrid
					rows={list}
					columns={columns}
					disableColumnMenu={true}
					localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
				/>
			</div>
		</div>
	);
}

export default PivotTable;
